'use strict';

/**
*        
*   ---=== FlexTools ===---
*   https://zhangfisher.github.com/flex-tools
* 
*   一些实用工具函数
*
*/
function n(t){return typeof t=="function"&&(t.$$isAsync||Object.prototype.toString.call(t)==="[object AsyncFunction]"||t.constructor&&t.constructor.name==="AsyncFunction")}

exports.a = n;
